import { useEffect, useState } from 'react';
import { subscribeSyncFailure } from '../utils/offline.js';

// One app-wide toast for queued-write failures: a save that succeeded locally
// while offline but was later REJECTED by the server (e.g. a rules mismatch).
// Mounted once at the app root (App.jsx). It never fires on the happy path —
// only when notifySyncFailure() runs — so it stays invisible in normal use.
export default function SyncToast() {
  const [msg, setMsg] = useState('');

  useEffect(() => subscribeSyncFailure((m) => setMsg(m || '')), []);

  useEffect(() => {
    if (!msg) return undefined;
    const t = setTimeout(() => setMsg(''), 6000);
    return () => clearTimeout(t);
  }, [msg]);

  if (!msg) return null;
  return (
    <div className="sync-toast" role="status" aria-live="polite" onClick={() => setMsg('')}>
      {msg}
    </div>
  );
}
